import { SendTitleService } from 'application/services/send-title'
import { api } from 'infra/adapters/http-client-adapter'

export const handleSendTitle = new SendTitleService(api)
